import { useQuery } from '@tanstack/react-query';
import ApiNet from '../../newApi/apiNet.ts';

export const useContests = () => {
    return useQuery({
        queryKey: ['contests'],
        queryFn: async () => await ApiNet.getContests(),
    });
};


export const useContestDetail = (id: string) => {
    return useQuery({
        queryKey: ['contests', id, 'details'],
        queryFn: async () => await ApiNet.getContestDetail(id),
    });
};

export const useContestAttempts = (id: string) => {
    return useQuery({
        queryKey: ['contests', id, 'attempts'],
        queryFn: async () => await ApiNet.getContestAttempts(id, {}),
    });
};

export const useContestAttemptVerifications = (contestId: string, enabled: boolean = true) => {
    return useQuery({
        enabled: enabled,
        queryKey: ['contests', contestId, 'attempts', 'verifications'],
        queryFn: async () => await ApiNet.getContestAttemptVerifications(contestId),
    });
};

export const useContestAttemptVerification = (contestId: string, attemptId?: string) => {
    return useQuery({
        enabled: !!attemptId,
        queryKey: ['contests', contestId, 'attempts', attemptId],
        queryFn: async () => await ApiNet.getContestAttemptVerification(contestId, attemptId!),
    });
};